import { WeeklySiteInspection } from './forms/weekly-site-inspection/weekly-site-inspection.model';
import { NearMissReport } from './forms/near-miss-report/near-miss-report.model';
import { HotWorkPermit } from './forms/hot-work-permit/hot-work-permit.model';
import { FallProtectionPlan } from './forms/fall-protection-plan/fall-protection-plan.model';
import { PreTaskSafetyPlan } from './forms/pre-task-safety-plan/pre-task-safety-plan.model';
import { ConfinedSpaceAlternateEntryForm } from './forms/confined-space-alt-entry/confined-space-alt-entry.model';
import { AerialAndScissorLift } from './forms/aerial-and-scissor-lift/aerial-and-scissor-lift.model';
import { ForkliftInspection } from './forms/forklift-inspection/forklift-inspection.model';
import { EmployeeInjuryReport } from './forms/employee-injury-report/employee-injury-report.model';
import { EnergizedElecWorkPermit } from './forms/energized-elec-work-permit/energized-elec-work-permit.model';

import { WeeklySiteInspectionComponent } from '../components/forms/form-submission/individual-forms/weekly-site-inspection/weekly-site-inspection.component';
import { NearMissReportComponent } from '../components/forms/form-submission/individual-forms/near-miss-report/near-miss-report.component';
import { HotWorkPermitComponent } from '../components/forms/form-submission/individual-forms/hot-work-permit/hot-work-permit.component';
import { FallProtectionPlanComponent } from '../components/forms/form-submission/individual-forms/fall-protection-plan/fall-protection-plan.component';
import { PreTaskSafetyPlanComponent } from '../components/forms/form-submission/individual-forms/pre-task-safety-plan/pre-task-safety-plan.component';
import { ConfinedSpaceAltEntryComponent } from '../components/forms/form-submission/individual-forms/confined-space-alt-entry/confined-space-alt-entry.component';
import { AerialAndScissorLiftComponent } from '../components/forms/form-submission/individual-forms/aerial-and-scissor-lift/aerial-and-scissor-lift.component';
import { ForkliftInspectionComponent } from '../components/forms/form-submission/individual-forms/forklift-inspection/forklift-inspection.component';
import { EmployeeInjuryReportComponent } from '../components/forms/form-submission/individual-forms/employee-injury-report/employee-injury-report.component';
import { EnergizedElecWorkPermitComponent } from '../components/forms/form-submission/individual-forms/energized-elec-work-permit/energized-elec-work-permit.component';
import { WeeklySiteInspectionListItem } from './forms/weekly-site-inspection/weekly-site-inspection-list-item.model';
import { NearMissReportListItem } from './forms/near-miss-report/near-miss-report-list-item.model';
import { HotWorkPermitListItem } from './forms/hot-work-permit/hot-work-permit-list-item.model';
import { FallProtectionPlanListItem } from './forms/fall-protection-plan/fall-protection-plan-list-item.model';
import { PreTaskSafetyPlanListItem } from './forms/pre-task-safety-plan/pre-task-safety-plan-list-item.model';
import { ConfinedSpaceAlternateEntryFormListItem } from './forms/confined-space-alt-entry/confined-space-alt-entry-list-item.model';
import { AerialAndScissorLiftListItem } from './forms/aerial-and-scissor-lift/aerial-and-scissor-lift-list-item.model';
import { ForkliftInspectionListItem } from './forms/forklift-inspection/forklift-inspection-list-item.model';
import { EmployeeInjuryReportListItem } from './forms/employee-injury-report/employee-injury-report-list-item.model';
import { EnergizedElecWorkPermitListItem } from './forms/energized-elec-work-permit/energized-elec-work-permit-list-item.model';
import { Component, Type } from '@angular/core';
import { TableColumn } from '../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { FormAttachmentUploadRequirements } from './forms/attachments/form-attachment-requirements';
import { FormGroup } from '@angular/forms';
import { SupervisorInjuryReport } from './forms/supervisor-injury-report/supervisor-injury-report.model';
import { SupervisorInjuryReportListItem } from './forms/supervisor-injury-report/supervisor-injury-report-list-item.model';
import { SupervisorInjuryReportComponent } from '../components/forms/form-submission/individual-forms/supervisor-injury-report/supervisor-injury-report.component';
import { JobSafetyAudit } from './forms/job-safety-audit/job-safety-audit.model';
import { JobSafetyAuditListItem } from './forms/job-safety-audit/job-safety-audit-list-item.model';
import { JobSafetyAuditComponent } from '../components/forms/form-submission/individual-forms/job-safety-audit/job-safety-audit.component';
import { FormStep } from './forms/form-steps.interface';
import { createFormFieldMetadata, FormFieldMetadata } from '../utils/field-type-extractor';
import { PfizerPreTaskSafetyPlan } from './forms/pfizer-pre-task-safety-plan/pfizer-pre-task-safety-plan.model';
import { PfizerPreTaskSafetyPlanListItem } from './forms/pfizer-pre-task-safety-plan/pfizer-pre-task-safety-plan-list-item.model';
import { PfizerPreTaskSafetyPlanComponent } from '../components/forms/form-submission/individual-forms/pfizer-pre-task-safety-plan/pfizer-pre-task-safety-plan.component';
import { VoluntaryRespiratorUse } from './forms/voluntary-respirator/voluntary-respirator.model';
import { VoluntaryRespiratorUseListItem } from './forms/voluntary-respirator/voluntary-respirator-list-item.model';
import { VoluntaryRespiratorUseComponent } from '../components/forms/form-submission/individual-forms/volunteer-respirator/volunteer-respirator.component';
import { TrenchingExcavationWorkPlan } from './forms/trenching-excavation-work-plan/trenching-excavation-work-plan.model';
import { TrenchingExcavationWorkPlanListItem } from './forms/trenching-excavation-work-plan/trenching-excavation-work-plan-list-item.model';
import { TrenchingExcavationWorkPlanComponent } from '../components/forms/form-submission/individual-forms/trenching-excavation-work-plan/trenching-excavation-work-plan.component';

export interface record<key, metadata> {
  [key: string]: metadata;
}

export interface FormMetadata {
  formType: string;
  title: string;
  cardImage: string;
  description?: string;
  icon: string;
  component: Type<any>;
  formModel: any;
  formListModel: any;
  tableColumns: TableColumn[];
  formSteps: FormStep[];
  formAttachmentRequirements: FormAttachmentUploadRequirements;
  fieldMappings: Record<string, string>;
  fieldMetadata?: FormFieldMetadata; // Auto-generated field type metadata

  accessControl?: FormAccessControl;
}


export interface FormAccessControl {
  // If true, requires Pfizer form access permission
  requiresPfizerAccess?: boolean;
  
  // If true, requires admin privileges
  requiresAdmin?: boolean;

  
  // Message to display when user lacks access
  accessDeniedMessage?: string;
}

export interface FormRegistry {
  [formType: string]: FormMetadata;
}

export const FORM_REGISTRY: FormRegistry = {
  [PreTaskSafetyPlan.getFormInfo().formType]: {
    title: PreTaskSafetyPlan.getFormInfo().formTitle,
    icon: PreTaskSafetyPlan.getFormInfo().formIcon,
    cardImage: PreTaskSafetyPlan.getFormInfo().cardImage,
    component: PreTaskSafetyPlanComponent,
    formModel: PreTaskSafetyPlan,
    formListModel: PreTaskSafetyPlanListItem,
    formType: PreTaskSafetyPlan.getFormInfo().formType,
    tableColumns: PreTaskSafetyPlanListItem.getTableColumns(),
    formSteps: PreTaskSafetyPlan.getFormSteps(),
    formAttachmentRequirements: PreTaskSafetyPlan.getFormInfo().formAttachmentRequirements,
    fieldMappings: PreTaskSafetyPlan.getFieldMappings(),
    fieldMetadata: createFormFieldMetadata(PreTaskSafetyPlan)
  },
    [PfizerPreTaskSafetyPlan.getFormInfo().formType]: {
    title: PfizerPreTaskSafetyPlan.getFormInfo().formTitle,
    icon: PfizerPreTaskSafetyPlan.getFormInfo().formIcon,
    cardImage: PfizerPreTaskSafetyPlan.getFormInfo().cardImage,
    component: PfizerPreTaskSafetyPlanComponent,
    formModel: PfizerPreTaskSafetyPlan,
    formListModel: PfizerPreTaskSafetyPlanListItem,
    formType: PfizerPreTaskSafetyPlan.getFormInfo().formType,
    tableColumns: PfizerPreTaskSafetyPlanListItem.getTableColumns(),
    formSteps: PfizerPreTaskSafetyPlan.getFormSteps(),
    formAttachmentRequirements: PfizerPreTaskSafetyPlan.getFormInfo().formAttachmentRequirements,
    fieldMappings: PfizerPreTaskSafetyPlan.getFieldMappings(),
    fieldMetadata: createFormFieldMetadata(PfizerPreTaskSafetyPlan),
    accessControl: PfizerPreTaskSafetyPlan.formAccessControl(),
  },
  [WeeklySiteInspection.getFormInfo().formType]: {
    title: WeeklySiteInspection.getFormInfo().formTitle,
    icon: WeeklySiteInspection.getFormInfo().formIcon,
    cardImage: WeeklySiteInspection.getFormInfo().cardImage,
    component: WeeklySiteInspectionComponent,
    formModel: WeeklySiteInspection,
    formListModel: WeeklySiteInspectionListItem,
    formType: WeeklySiteInspection.getFormInfo().formType,
    tableColumns: WeeklySiteInspectionListItem.getTableColumns(),
    formAttachmentRequirements: WeeklySiteInspection.getFormInfo().formAttachmentRequirements,
    fieldMappings: WeeklySiteInspection.getFieldMappings(),
    formSteps: WeeklySiteInspection.getFormSteps(),
    fieldMetadata: createFormFieldMetadata(WeeklySiteInspection)
  },


  

  [AerialAndScissorLift.getFormInfo().formType]: {
    title: AerialAndScissorLift.getFormInfo().formTitle,
    icon: AerialAndScissorLift.getFormInfo().formIcon,
    cardImage: AerialAndScissorLift.getFormInfo().cardImage,
    component: AerialAndScissorLiftComponent,
    formModel: AerialAndScissorLift,
    formListModel: AerialAndScissorLiftListItem,
    formType: AerialAndScissorLift.getFormInfo().formType,
    tableColumns: AerialAndScissorLiftListItem.getTableColumns(),
    formAttachmentRequirements: AerialAndScissorLift.getFormInfo().formAttachmentRequirements,
    fieldMappings: AerialAndScissorLift.getFieldMappings(),
    formSteps: AerialAndScissorLift.getFormSteps(),
    fieldMetadata: createFormFieldMetadata(AerialAndScissorLift)
  },
  [ForkliftInspection.getFormInfo().formType]: {
    title: ForkliftInspection.getFormInfo().formTitle,
    icon: ForkliftInspection.getFormInfo().formIcon,
    cardImage: ForkliftInspection.getFormInfo().cardImage,
    component: ForkliftInspectionComponent,
    formModel: ForkliftInspection,
    formListModel: ForkliftInspectionListItem,
    formType: ForkliftInspection.getFormInfo().formType,
    tableColumns: ForkliftInspectionListItem.getTableColumns(),
    formAttachmentRequirements: ForkliftInspection.getFormInfo().formAttachmentRequirements,
    fieldMappings: ForkliftInspection.getFieldMappings(),
    formSteps: ForkliftInspection.getFormSteps(),
    fieldMetadata: createFormFieldMetadata(ForkliftInspection)
  },

  [ConfinedSpaceAlternateEntryForm.getFormInfo().formType]: {
    title: ConfinedSpaceAlternateEntryForm.getFormInfo().formTitle,
    icon: ConfinedSpaceAlternateEntryForm.getFormInfo().formIcon,
    cardImage: ConfinedSpaceAlternateEntryForm.getFormInfo().cardImage,
    component: ConfinedSpaceAltEntryComponent,
    formModel: ConfinedSpaceAlternateEntryForm,
    formListModel: ConfinedSpaceAlternateEntryFormListItem,
    formType: ConfinedSpaceAlternateEntryForm.getFormInfo().formType,
    tableColumns: ConfinedSpaceAlternateEntryFormListItem.getTableColumns(),
    formAttachmentRequirements: ConfinedSpaceAlternateEntryForm.getFormInfo().formAttachmentRequirements,
    fieldMappings: ConfinedSpaceAlternateEntryForm.getFieldMappings(),
    formSteps: ConfinedSpaceAlternateEntryForm.getFormSteps(),
    fieldMetadata: createFormFieldMetadata(ConfinedSpaceAlternateEntryForm)
  },


  [FallProtectionPlan.getFormInfo().formType]: {
    title: FallProtectionPlan.getFormInfo().formTitle,
    icon: FallProtectionPlan.getFormInfo().formIcon,
    cardImage: FallProtectionPlan.getFormInfo().cardImage,
    component: FallProtectionPlanComponent,
    formModel: FallProtectionPlan,
    formListModel: FallProtectionPlanListItem,
    formType: FallProtectionPlan.getFormInfo().formType,
    tableColumns: FallProtectionPlanListItem.getTableColumns(),
    formAttachmentRequirements: FallProtectionPlan.getFormInfo().formAttachmentRequirements,
    fieldMappings: FallProtectionPlan.getFieldMappings(),
    formSteps: FallProtectionPlan.getFormSteps(),
    fieldMetadata: createFormFieldMetadata(FallProtectionPlan)
  },

  [EnergizedElecWorkPermit.getFormInfo().formType]: {
    title: EnergizedElecWorkPermit.getFormInfo().formTitle,
    icon: EnergizedElecWorkPermit.getFormInfo().formIcon,
    cardImage: EnergizedElecWorkPermit.getFormInfo().cardImage,
    component: EnergizedElecWorkPermitComponent,
    formModel: EnergizedElecWorkPermit,
    formListModel: EnergizedElecWorkPermitListItem,
    formType: EnergizedElecWorkPermit.getFormInfo().formType,
    tableColumns: EnergizedElecWorkPermitListItem.getTableColumns(),
    formAttachmentRequirements: EnergizedElecWorkPermit.getFormInfo().formAttachmentRequirements,
    fieldMappings: EnergizedElecWorkPermit.getFieldMappings(),
    formSteps: EnergizedElecWorkPermit.getFormSteps(),
    fieldMetadata: createFormFieldMetadata(EnergizedElecWorkPermit)
  },
  [HotWorkPermit.getFormInfo().formType]: {
    title: HotWorkPermit.getFormInfo().formTitle,
    icon: HotWorkPermit.getFormInfo().formIcon,
    cardImage: HotWorkPermit.getFormInfo().cardImage,
    component: HotWorkPermitComponent,
    formModel: HotWorkPermit,
    formListModel: HotWorkPermitListItem,
    formType: HotWorkPermit.getFormInfo().formType,
    tableColumns: HotWorkPermitListItem.getTableColumns(),
    formAttachmentRequirements: HotWorkPermit.getFormInfo().formAttachmentRequirements,
    fieldMappings: HotWorkPermit.getFieldMappings(),
    formSteps: HotWorkPermit.getFormSteps(),
    fieldMetadata: createFormFieldMetadata(HotWorkPermit)
  },
  [NearMissReport.getFormInfo().formType]: {
    title: NearMissReport.getFormInfo().formTitle,
    icon: NearMissReport.getFormInfo().formIcon,
    cardImage: NearMissReport.getFormInfo().cardImage,
    component: NearMissReportComponent,
    formModel: NearMissReport,
    formListModel: NearMissReportListItem,
    formType: NearMissReport.getFormInfo().formType,
    tableColumns: NearMissReportListItem.getTableColumns(),
    formAttachmentRequirements: NearMissReport.getFormInfo().formAttachmentRequirements,
    fieldMappings: NearMissReport.getFieldMappings(),
    formSteps: NearMissReport.getFormSteps(),
    fieldMetadata: createFormFieldMetadata(NearMissReport)
  },
  [EmployeeInjuryReport.getFormInfo().formType]: {
    title: EmployeeInjuryReport.getFormInfo().formTitle,
    icon: EmployeeInjuryReport.getFormInfo().formIcon,
    cardImage: EmployeeInjuryReport.getFormInfo().cardImage,
    component: EmployeeInjuryReportComponent,
    formModel: EmployeeInjuryReport,
    formListModel: EmployeeInjuryReportListItem,
    formType: EmployeeInjuryReport.getFormInfo().formType,
    tableColumns: EmployeeInjuryReportListItem.getTableColumns(), 
    formAttachmentRequirements: EmployeeInjuryReport.getFormInfo().formAttachmentRequirements,
    fieldMappings: EmployeeInjuryReport.getFieldMappings(),
    formSteps: EmployeeInjuryReport.getFormSteps(),
    fieldMetadata: createFormFieldMetadata(EmployeeInjuryReport)
  },
  [SupervisorInjuryReport.getFormInfo().formType]: {
    title: SupervisorInjuryReport.getFormInfo().formTitle,
    icon: SupervisorInjuryReport.getFormInfo().formIcon,
    cardImage: SupervisorInjuryReport.getFormInfo().cardImage,
    component: SupervisorInjuryReportComponent,
    formModel: SupervisorInjuryReport,
    formListModel: SupervisorInjuryReportListItem,
    formType: SupervisorInjuryReport.getFormInfo().formType,
    tableColumns: SupervisorInjuryReportListItem.getTableColumns(),
    formAttachmentRequirements: SupervisorInjuryReport.getFormInfo().formAttachmentRequirements,
    fieldMappings: SupervisorInjuryReport.getFieldMappings(),
    formSteps: SupervisorInjuryReport.getFormSteps(),
    fieldMetadata: createFormFieldMetadata(SupervisorInjuryReport)
  },
  [JobSafetyAudit.getFormInfo().formType]: {
    title: JobSafetyAudit.getFormInfo().formTitle,
    icon: JobSafetyAudit.getFormInfo().formIcon,
    cardImage: JobSafetyAudit.getFormInfo().cardImage,
    component: JobSafetyAuditComponent,
    formModel: JobSafetyAudit,
    formListModel: JobSafetyAuditListItem,
    formType: JobSafetyAudit.getFormInfo().formType,
    tableColumns: JobSafetyAuditListItem.getTableColumns(),
    formAttachmentRequirements: JobSafetyAudit.getFormInfo().formAttachmentRequirements,
    fieldMappings: JobSafetyAudit.getFieldMappings(),
    formSteps: JobSafetyAudit.getFormSteps(),
    fieldMetadata: createFormFieldMetadata(JobSafetyAudit)
  },
  [VoluntaryRespiratorUse.getFormInfo().formType]: {
    title: VoluntaryRespiratorUse.getFormInfo().formTitle,
    icon: VoluntaryRespiratorUse.getFormInfo().formIcon,
    cardImage: VoluntaryRespiratorUse.getFormInfo().cardImage,
    component: VoluntaryRespiratorUseComponent,
    formModel: VoluntaryRespiratorUse,
    formListModel: VoluntaryRespiratorUseListItem,
    formType: VoluntaryRespiratorUse.getFormInfo().formType,
    tableColumns: VoluntaryRespiratorUseListItem.getTableColumns(),
    formAttachmentRequirements: VoluntaryRespiratorUse.getFormInfo().formAttachmentRequirements,
    fieldMappings: VoluntaryRespiratorUse.getFieldMappings(),
    formSteps: VoluntaryRespiratorUse.getFormSteps(),
    fieldMetadata: createFormFieldMetadata(VoluntaryRespiratorUse)
  },
  [TrenchingExcavationWorkPlan.getFormInfo().formType]: {
    title: TrenchingExcavationWorkPlan.getFormInfo().formTitle,
    icon: TrenchingExcavationWorkPlan.getFormInfo().formIcon,
    cardImage: TrenchingExcavationWorkPlan.getFormInfo().cardImage,
    component: TrenchingExcavationWorkPlanComponent,
    formModel: TrenchingExcavationWorkPlan,
    formListModel: TrenchingExcavationWorkPlanListItem,
    formType: TrenchingExcavationWorkPlan.getFormInfo().formType,
    tableColumns: TrenchingExcavationWorkPlanListItem.getTableColumns(),
    formAttachmentRequirements: TrenchingExcavationWorkPlan.getFormInfo().formAttachmentRequirements,
    fieldMappings: TrenchingExcavationWorkPlan.getFieldMappings(),
    formSteps: TrenchingExcavationWorkPlan.getFormSteps(),
    fieldMetadata: createFormFieldMetadata(TrenchingExcavationWorkPlan)
  },

};

/**
 * Utility function to get all field metadata for a form
 * Uses the pre-computed field metadata from the registry
 */
export function getFormFieldMetadata(formType: string): FormFieldMetadata | undefined {
  const formInfo = FORM_REGISTRY[formType];
  return formInfo?.fieldMetadata;
}